import { render, staticRenderFns } from "./DocumentTemplateMedicalCertificatePreview.vue?vue&type=template&id=12362c08&scoped=true&lang=pug&"
import script from "./DocumentTemplateMedicalCertificatePreview.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateMedicalCertificatePreview.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTemplateMedicalCertificatePreview.vue?vue&type=style&index=0&id=12362c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12362c08",
  null
  
)

export default component.exports